import React from 'react'
import PropTypes from 'prop-types'
import { numberToStrCurrency } from 'Shared/CurrencyLabel/CurrencyLabel'
import moment from 'moment'
import { Link } from 'react-router-dom'

export default function OrderSummary ({ parentOrderId, selectedDiscount, pointsName, orderId, itemId }) {
  const orderLabel = `Pedido: #${parentOrderId}`
  const creditValueLabel = `R$ ${numberToStrCurrency(selectedDiscount !== null ? selectedDiscount.credit : 0, 2)}`
  const orderDateLabel = `${moment().format('DD/MM/YYYY')}`

  return (
    <div className='order-summary-invoice-credit col-md col-12 border border-color-ui-2 radius bg-white mt-4 mr-md-3 p-0'>
      <div className='border-bottom border-color-ui-2 px-2 py-3'>
        <h1 className='h3'>
          Resumo do pedido
        </h1>
      </div>

      <div className='p-2'>
        <div className='d-flex align-items-start flex-wrap justify-content-between'>
          <div aria-hidden className='col-1 radius border border-color-ui-2 px-3 d-flex align-items-center justify-content-center'>
            <img className='logo-invoice' />
          </div>

          <div className='col-md col-9'>
            <p>
              <strong className='txt-body-sm color-brand-4'>{orderLabel}</strong>
            </p>
            <p className='my-1'>
              <strong className='txt-body-sm color-brand-4'>Resgate de créditos na fatura</strong>
            </p>
            <div>
              <p aria-label={`Valor: ${selectedDiscount.points} ${pointsName}`}>
                <span aria-hidden>
                  Valor: <strong className='txt-body-sm color-brand-4'>{selectedDiscount.points} {pointsName}</strong>
                </span>
              </p>
              <p aria-label={`Valor em crédito: ${creditValueLabel}`}>
                Valor em crédito: <strong className='txt-body-sm color-brand-4'>{creditValueLabel}</strong>
              </p>
              <p aria-label={`Realizado em: ${orderDateLabel}`}>
                Realizado em: <strong className='txt-body-sm color-brand-4'>{orderDateLabel}</strong>
              </p>
            </div>
          </div>
          <div className='col-auto button-see-order'>
            <Link
              id='see-order-invoice-credit'
              className='btn-icon btn btn-sm btn-cart btn-icon'
              to={`/order/${parentOrderId}/${orderId}/product/${itemId}`}>
              Ver pedido
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

OrderSummary.propTypes = {
  parentOrderId: PropTypes.number,
  orderId: PropTypes.number,
  itemId: PropTypes.number,
  selectedDiscount: PropTypes.object,
  pointsName: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/features/InvoiceCredit/OrderSummary.js